export const ADD_ONS = 'Add-ons';
export const CLASSROOM_TRAINING_SERVICES = 'Classroom Training Services';
export const CMS_HUB_PRODUCTS = 'CMS Hub Products';
export const CONSULTING_SERVICE = 'Consulting Service';
export const MARKETING_CONTACTS = 'Marketing Contacts';
export const MARKETING_PRODUCTS = 'Marketing Products';
export const MIGRATION_AND_TEMPLATE_SETUP = 'Migration & Template Setups';
export const ONBOARDING_SERVICES = 'Onboarding Services';
export const OTHER = 'Other';
export const PREMIER_SERVICES = 'Premier Services';
export const SALES_PRODUCTS = 'Sales Products';
export const SERVICE_HUB_PRODUCTS = 'Service Hub Products';
export const SIDEKICK = 'Sidekick';
export const CORE_PLATFORM_SEATS = 'Core Platform Seats';